module.exports = __webpack_public_path__ + "media/assets/images/blog/binarysystem_wallpaper-small-d70b437c7883c7fa3279e8ea06c698fe.jpg";